import React, { useEffect, useRef, useState } from 'react'

// A muted, looping project video that plays only while it is on screen.
// The button in the corner turns the sound on and off.

const ProjectVideo = ({ src, title }) => {
  const videoRef = useRef(null)
  const [muted, setMuted] = useState(true)

  useEffect(() => {
    const v = videoRef.current
    if (!v || !('IntersectionObserver' in window)) return
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) v.play().catch(() => {})
        else v.pause()
      },
      { threshold: 0.35 }
    )
    io.observe(v)
    return () => io.disconnect()
  }, [])

  return (
    <>
      <video
        ref={videoRef}
        src={src}
        muted={muted}
        loop
        playsInline
        preload='metadata'
        aria-label={title}
      />
      <button
        className='project-row__sound'
        onClick={() => setMuted((m) => !m)}
        aria-label={muted ? 'Turn sound on' : 'Turn sound off'}
      >
        <i className={`fa-solid ${muted ? 'fa-volume-xmark' : 'fa-volume-high'}`} />
      </button>
    </>
  )
}

export default ProjectVideo
